module.exports = __webpack_public_path__ + "static/media/web-search-recent-alerts.8f821e42.png";